const ApplicationConstants = {
  drawerWidth: 240
};

export default ApplicationConstants;
